import {currency, currentLanguage, history, labels} from '../globals/config';
import switchStep from '../components/switchStep';
import {garageLocatorData} from './garageLocator';
import {apSwitchStep} from '../../appointment-tool/components/apSwitchStep';
import {garageInfoModal, toggleGarageInfoModal} from '../../appointment-tool/modules/vehicleSelector';
import toolLoader from '../../appointment-tool/components/toolLoader';
import {replacementData, replacements} from './replacements';
import apAnalytics from '../../appointment-tool/components/apAnalytics';
import qtAnalytics from '../components/qtAnalytics';

const $ = jQuery;
let calendarData;
const currentNow = new Date();
let currentWeekNumber = getWeekNumber(currentNow);
const $toolsContainer = $('#quote-tool, #appointment-tool');

/**
 * Date selector data
 * @type {{date: string, fullDate: string, slotId: number, time: string}}
 */
export let dateSelectorData = {
    fullDate: '',
    date: '',
    time: '',
    slotId: 0,
}

/**
 * Date selector module
 */
export function dateSelector() {
    switchWeeks();
    updateDateData();
    scheduleValidation();
    scheduleSubmit();
    triggerScheduleCalendarModal();

    $('#qt-schedule-privacy-checkbox').on('click', function () {
        scheduleValidation();
    });
}

/**
 * Get calendar from WACS
 */
export function getCalendarFromWacs() {
    $.ajax({
        type: 'GET',
        url: menaObject.ajaxurl,
        dataType: 'html',
        data: {
            action: 'qtGetWacsDates',
            garageID: garageLocatorData.garageID,
        },
        beforeSend: function () {
            $('.js-qt-schedule--weeks').empty();
        },
        success: function (response) {
            let data;

            try {
                data = JSON.parse(response);
            } catch (e) {
                handleNoDatesAvailable();
                return;
            }

            if (!data || !Array.isArray(data) || data.length === 0) {
                handleNoDatesAvailable();
                return;
            }

            calendarData = fetchDatesFromWacs(data);
            generateCalendar(calendarData);
            toolLoader(true);
        },
        error: function () {
            handleNoDatesAvailable();
        },
    });
}

/**
 * Handle no dates available from WACS — show message and return to dealer selection
 */
function handleNoDatesAvailable() {
    toolLoader(true);

    const noDateMessage = menaObject.labels.schedule.no_dates
        || 'Il n\'y a pas de créneaux disponibles pour le garage sélectionné. Veuillez choisir un autre garage.';

    const $weeksDiv = $('.js-qt-schedule--weeks');
    $weeksDiv.empty();
    $weeksDiv.append(
        `<div class="c-qt-schedule__no-dates" style="text-align:center;padding:2rem;">
            <p class="font-bold">${noDateMessage}</p>
        </div>`
    );

    // Return user to dealer selection after a short delay
    setTimeout(function () {
        history.pop();
        switchStep('garage-locator');
    }, 3000);
}

/**
 * Fetch dates from WACS
 */
function fetchDatesFromWacs(data) {
    let formatDaysArray = [];

    if (!data || !Array.isArray(data) || data.length === 0) {
        return formatDaysArray;
    }

    data.forEach((date) => {
        const slotDate = new Date(date.Date);

        // Format date to "yyyy-mm-dd" (assuming you want the date in this format)
        const formattedDate = formatDate(slotDate);

        // Get day and month (3-letter representation)
        const day = slotDate.toLocaleString(currentLanguage, {weekday: 'short'}).slice(0, -1);
        const dayNumber = slotDate.getDate();
        const month = slotDate.toLocaleString(currentLanguage, {month: 'short'}).slice(0, -1);
        const monthNumber = slotDate.getMonth() + 1;
        const year = slotDate.getFullYear();
        let slots = [];


        // Extract information for each slot
        date.Slots.forEach(slot => {
            const startTime = formatTime(slot.Start);
            const endTime = formatTime(slot.End);

            slots.push({
                slotId: slot.SlotId,
                startTime: startTime,
                endTime: endTime,
            });
        });

        // Push the date to the array
        formatDaysArray.push({
            fullDate: formattedDate,
            date: `${dayNumber} ${month}`,
            day: day,
            rowDay: dayNumber,
            month: monthNumber,
            monthName: month,
            year: year,
            slots: slots,
        });
    });

    if (formatDaysArray.length > 0) {
        formatDaysArray = formatInWeeks(formatDaysArray);
    }

    return formatDaysArray;
}

/**
 * Generate calendar html
 * @param weeks
 */
function generateCalendar(weeks) {
    let $weeksDiv = $('.js-qt-schedule--weeks');
    $weeksDiv.empty();

    if (weeks) {
		$('.js-schedule--garage-name').text(garageLocatorData.name);
		let $weekContainer = $('.js-qt-schedule--weeks');

		// if (!weeks[currentWeekNumber]) {
		//     let keys = Object.keys(weeks);
		//     currentWeekNumber = parseInt(keys[0]);
		// }

		let hasActiveWeek = false;

		$.each(weeks, function (weekNum, weekData) {
			weekNum = parseInt(weekData.weekNumber);

			let weekForShow = currentWeekNumber;
			// Add +1 to current week number if it's Friday, Saturday or Sunday but if is end of the year then set it to 1

			if (currentNow.getDay() === 5 || currentNow.getDay() === 6 || currentNow.getDay() === 0) {
				if (weekForShow === 52) {
					weekForShow = 1;
				} else {
					weekForShow = weekForShow + 1;
				}
			}

			let activeClass = '';

			if (weekNum === weekForShow) {
				//if (weekNum === 1) { // TESTING ONLY!
				activeClass = 'active';
				hasActiveWeek = true;
				changeMonthHeading(weekNum, weekData.items[0].fullDate);
			}

			let $weekHtml = addCalendarHtml();
			$weekContainer.append($weekHtml);
			disabledDays();

			function addCalendarHtml() {
				let $daysDiv = $(`<div class="c-qt-schedule__days ${activeClass}" data-week-num="${weekNum}"></div>`);
				weekData.items.forEach((day, index) => {
					// Prepare day div
					let $dayDiv = $(`<div class="c-qt-schedule__day js-qt-schedule--day" data-date="${day.fullDate}">
                                <p class="opacity-65 mb-0 font-bold text-capitalize">${day.day}</p>
                                <p class="font-medium opacity-65 js-qt-schedule--date font-12" data-day="${day.rowDay}" data-month="${day.month}" data-year="${day.year}">${day.date}</p>
                            </div>`);

					// Fill slots
					let daySlotsLength = day.slots.length;
					let $timeslots = $(`<div class="js-qt-schedule--timeslots" data-timeslots-index="${index}"></div>`);
					if (daySlotsLength !== 0) {
						const slotsLength = day.slots.length;
						day.slots.forEach(function (slot, index) {
							$timeslots.append(`<div class="c-qt-schedule__slot js-qt-schedule--slot" data-slot-id="${slot.slotId}"><span class="opacity-5">${slot.startTime}</span></div>`);
						});
					} else {
						let $emptySlot = $('<div class="c-qt-schedule__empty-slot"></div>');
						$emptySlot.append(`<svg xmlns="http://www.w3.org/2000/svg" width="32.465" height="37.06" viewBox="0 0 32.465 37.06">
                                      <g id="Pas-date" transform="translate(0.999 1)">
                                        <line id="Line_326" data-name="Line 326" x2="5.519" y2="5.519" transform="translate(12.474 19.601)" fill="none" stroke="#e48c74" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <line id="Line_327" data-name="Line 327" x1="5.519" y2="5.519" transform="translate(12.474 19.601)" fill="none" stroke="#e48c74" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <circle id="Ellipse_534" data-name="Ellipse 534" cx="6.717" cy="6.717" r="6.717" transform="translate(8.517 15.644)" fill="none" stroke="#e48c74" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <line id="Line_328" data-name="Line 328" x1="12.172" transform="translate(9.066 4.283)" fill="none" stroke="#25323e" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <path id="Path_10225" data-name="Path 10225" d="M28.627,25.37H25.109a1.782,1.782,0,0,0-1.739,1.824V54.323a1.785,1.785,0,0,0,1.739,1.824H46.261a.786.786,0,0,0,.567-.244l2.111-2.2,1.736-1.817a.86.86,0,0,0,.237-.6V27.194a1.785,1.785,0,0,0-1.739-1.824H45.493" transform="translate(-21.906 -21.087)" fill="none" stroke="#25323e" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <line id="Line_329" data-name="Line 329" x2="30.465" transform="translate(0.001 11.796)" fill="none" stroke="#25323e" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <path id="Path_10226" data-name="Path 10226" d="M39.383,13.28h0a1.172,1.172,0,0,1,1.173,1.173v6.224a1.172,1.172,0,0,1-1.173,1.173h0a1.172,1.172,0,0,1-1.173-1.173V14.453a1.172,1.172,0,0,1,1.173-1.173Z" transform="translate(-31.489 -13.28)" fill="none" stroke="#e48c74" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                        <rect id="Rectangle_2287" data-name="Rectangle 2287" width="2.345" height="8.569" rx="1.173" transform="translate(21.238 0)" fill="none" stroke="#e48c74" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
                                      </g>
                                    </svg>`);
						$emptySlot.append(`<span class="font-12 mt-1 font-bold">${labels.emptySlot}</span>`);
						$timeslots.append($emptySlot);
					}

					// Append timeslots to day
					$dayDiv.append($timeslots);

					// Append day to week
					$daysDiv.append($dayDiv);
				});

				// Append week to weeks
				$weeksDiv.hide();
				$weeksDiv.append($daysDiv);
				$weeksDiv.slideDown(200);

				return $daysDiv;
			}
		});

		// After all weeks are generated, check if any week has the active class
		if (!hasActiveWeek) {
			const $firstWeek = $weekContainer.find('.c-qt-schedule__days').first();
			$firstWeek.addClass('active');

			// Update the month heading with the first week's first item's date
			const firstWeekData = weeks[0]; // Assuming 'weeks' is an array
			changeMonthHeading(firstWeekData.weekNumber, firstWeekData.items[0].fullDate);
		}
	}

    $('#quote-tool section.active').removeClass('active');
    $(`#quote-tool section[data-step-name="schedule"]`).addClass('active');

    if ($('body.page-template-appointment').length > 0) {
        apAnalytics('choose-date--start');
    }
}

/**
 * Format date to "yyyy-mm-dd" (assuming you want the date in this format)
 * @param dateObject
 * @returns {string}
 */
function formatDate(dateObject) {
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(dateObject.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

/**
 * Format time to "hh:mm"
 * @param timeString
 * @returns {string}
 */
export function formatTime(timeString) {
    const [hours, minutes] = timeString.split(':');
    return `${parseInt(hours)}h${minutes}`;
}

/**
 * Format dates in weeks
 * @param dateArray
 */
function formatInWeeks(dateArray) {
    const weeks = []; // Initialize as an array

	dateArray.forEach((item) => {
		let weekNumber = getWeekNumber(item.fullDate);
		weekNumber = parseInt(weekNumber);

		// Check if the week already exists in the array
		let weekIndex = weeks.findIndex((entry) => entry.weekNumber === weekNumber);

		if (weekIndex === -1) {
			// Add a new week entry at the end
			weeks.push({ weekNumber, items: [item] });
		} else {
			// Append to the existing week's items
			weeks[weekIndex].items.push(item);
		}
	});

    return weeks;
}

/**
 * Get week number
 * @param d
 * @returns {number}
 */
export function getWeekNumber(d) {
    const date = new Date(d);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const yearStart = new Date(date.getFullYear(), 0, 1);
    const weekNumber = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
    return weekNumber;
}

/**
 * Change month heading
 * @param weekNumber
 * @param date
 */
function changeMonthHeading(weekNumber, date) {
    const $monthHeading = $('.js-qt-schedule--month');
    const dateObject = new Date(date);
    const year = dateObject.getFullYear();
    let month = dateObject.getMonth();
    month = labels.months[month];

    $monthHeading.text(`${month} ${year}`);
    setInactiveArrows(weekNumber);
}

/**
 * Set inactive arrows
 * @param weekNumber
 */
function setInactiveArrows(weekNumber) {
    weekNumber = parseInt(weekNumber);
    const keys = Object.keys(calendarData);

    if (weekNumber === parseInt(keys[0])) {
        $('.js-schedule--previous-week').addClass('hidden');
    } else if (weekNumber === parseInt(keys[keys.length - 1])) {
        $('.js-schedule--next-week').addClass('hidden');
    } else {
        $('.js-schedule--previous-week').removeClass('hidden');
        $('.js-schedule--next-week').removeClass('hidden');
    }
}

/**
 * Switch weeks
 */
function switchWeeks() {
    $toolsContainer.on('click', '.js-schedule--previous-week', function () {
        changeWeek(-1);
    });

    $toolsContainer.on('click', '.js-schedule--next-week', function () {
        changeWeek(1);
    });

    function changeWeek(num) {
		const $weeks = $('.js-qt-schedule--weeks');
		const $activeWeek = $weeks.find(`.c-qt-schedule__days.active`);
		const currentWeekNumber = parseInt($activeWeek.data('week-num'));

		// Calculate the target week number with wrap-around logic
		let targetWeekNumber = currentWeekNumber + num;

		// Wrap-around conditions
		if (targetWeekNumber > 52) {
			targetWeekNumber = 1;
		} else if (targetWeekNumber < 1) {
			targetWeekNumber = 52;
		}

		// Find the target week data from calendarData
		const targetWeek = calendarData.find((week) => week.weekNumber === targetWeekNumber);

		if (targetWeek) {
			const $newWeek = $weeks.find(`.c-qt-schedule__days[data-week-num="${targetWeekNumber}"]`);

			// Update active week class
			$activeWeek.removeClass('active');
			$newWeek.addClass('active');

			// Update the month heading using the first item's date
			if (targetWeek.items.length > 0) {
				const firstItem = targetWeek.items[0];
				changeMonthHeading(targetWeekNumber, firstItem.fullDate);
			} else {
				console.warn(`Week ${targetWeekNumber} has no items.`);
			}
		} else {
			console.error(`Week ${targetWeekNumber} not found in calendarData.`);
		}
	}
}

/**
 * Disabled past days
 */
function disabledDays() {
    const $days = $('.js-qt-schedule--day');

    $days.each(function () {
        const $day = $(this);
        let currentDate = new Date(currentNow);
        let date = $day.data('date');
        date = new Date(date).getTime();

        // // Get current time +48h but if it's Friday, Saturday or Sunday then +72h
        // if (currentDate.getDay() === 5 || currentDate.getDay() === 6 || currentDate.getDay() === 0) {
        //     currentDate.setDate(currentDate.getDate() + 3);
        // } else {
        //     currentDate.setDate(currentDate.getDate() + 2);
        // }

        let currentTime = currentDate.getTime();
        if (date < currentTime) {
            $day.addClass('disabled');
        }
    });
}

/**
 * Update date data
 */
function updateDateData() {
    $toolsContainer.on('click', '.js-qt-schedule--slot', function () {
        const $slot = $(this);
        const $day = $slot.closest('.js-qt-schedule--day');
        const date = $day.data('date');
        const time = formatTime($slot.find('span').text());
        const [year, month, day] = date.split('-');
        const [hours, minutes] = time.split(':');

        $('.js-qt-schedule--slot.selected').removeClass('selected');
        $slot.addClass('selected');

        dateSelectorData.fullDate = new Date(parseInt(year), parseInt(month - 1), parseInt(day), parseInt(hours), parseInt(minutes));
        dateSelectorData.date = date;
        dateSelectorData.time = time;
        dateSelectorData.slotId = $slot.closest('.js-qt-schedule--slot').data('slot-id');

        changeInfoText($slot);

        scheduleValidation();
        getReplacementAvailability();
    });

    function formatTime(timeString) {
        const [hours, minutes] = timeString.split('h');
        return `${parseInt(hours)}:${minutes}`;
    }
}

/**
 * Change info text
 * @param $timeSlot
 */
function changeInfoText($timeSlot) {
    const $textContainer = $('.c-qt-schedule__middle-text');
    const $selectedSlot = $textContainer.find('.js-qt-schedule--text-info-slot');

    $selectedSlot.text($timeSlot.find('span').text() + '.');

    $textContainer.slideDown(200);
}

/**
 * Schedule submit.
 */
function scheduleSubmit() {
    $toolsContainer.on('click', '.js-qt-schedule--submit', qtSubmit);
    $toolsContainer.on('click', '.js-ap-schedule--submit', apSubmit);

    function qtSubmit() {
        let option = `${dateSelectorData.date} | ${dateSelectorData.time}`;

        if (replacementData.slug) {
            option += ` | ${replacementData.slug}`;
        }

        // Check if current button has class c-button--disabled
        if ($(this).hasClass('c-button--disabled')) {
			// Find element with class c-qt-schedule__bottom and scroll to it with scrollintoview
            const $scheduleBottom = $('.c-qt-schedule__bottom');
            $scheduleBottom[0].scrollIntoView({behavior: 'smooth'});
			return;
		}

        qtAnalytics('date-picker-submit', option);
        switchStep('user_info');
        history.push('user_info');
    }

    function apSubmit() {
        apSwitchStep('vehicle-select');

        if ($('body.page-template-appointment').length > 0) {
            apAnalytics('choose-date--submit', `${dateSelectorData.date} | ${dateSelectorData.time}`);
            apAnalytics('vehicle-info--start');
        }
    }
}

/**
 * Validate schedule
 */
function scheduleValidation() {
    let validation = false;
    let $scheduleButton = $('.js-qt-schedule--submit');

    if ($('#appointment-tool').length > 0) {
        $scheduleButton = $('.js-ap-schedule--submit');

        if (dateSelectorData.slotId > 0) {
            validation = true;
        }
    } else {
        if ($('#qt-schedule-privacy-checkbox').is(':checked')) {
            if (dateSelectorData.slotId > 0) {
                validation = true;
            }
        }
    }

    if (validation) {
        if ($scheduleButton.hasClass('c-button--disabled')) {
            $scheduleButton.removeClass('c-button--disabled');
        }
    } else {
        if (!$scheduleButton.hasClass('c-button--disabled')) {
            $scheduleButton.addClass('c-button--disabled');
        }
    }
}

/**
 * Trigger schedule calendar modal
 */
function triggerScheduleCalendarModal() {
    if ($('#appointment-tool, #quote-tool').length > 0) {
        $('.js-qt-schedule--calendar-contact-modal').on('click', function (e) {
            e.preventDefault();
            garageInfoModal('vehicle-select-contact-modal');
            toggleGarageInfoModal('vehicle-select-contact-modal');
        });
    }

    if ($('#quote-tool').length > 0) {
        // if click outside of modal then close it
        $(document).click(function (e) {
            const $modal = $('#vehicle-select-contact-modal');
            if ($modal.is(e.target) && !$('.c-ap-garage-info-modal__container').is(e.target)) {
                toggleGarageInfoModal('vehicle-select-contact-modal');
            }
        });
    }
}

/**
 * Get replacement availability
 */
function getReplacementAvailability() {
    $.ajax({
        type: 'GET',
        url: menaObject.ajaxurl,
        dataType: 'html',
        data: {
            action: 'qtReplacementAvailability',
            date: dateSelectorData.date,
            garageID: parseInt(garageLocatorData.garageID),
        },
        success: function (response) {
            const data = JSON.parse(response);
            if (data && data.AssetPrices) {
                const assetPrices = data.AssetPrices;
                const $bikeCarReplacement = $('.js-qt-replacement--item[data-slug="bike"][data-duration="day"]');
                const $dayCarReplacement = $('.js-qt-replacement--item[data-slug="car"][data-duration="day"]');
                const $halfDayCarReplacement = $('.js-qt-replacement--item[data-slug="car"][data-duration="half_day"]');
                let dayPrice = 0;
                let halfDayPrice = 0;
                let isHaveReplacement = false;

                assetPrices.forEach((assetPrice) => {
                    console.log(assetPrice);
                    if (assetPrice.TrueType === 'Vélo') {
                        $bikeCarReplacement.attr('data-price', assetPrice.DayPrice);
                        isHaveReplacement = true;
                    }

                    if (assetPrice.TrueType === 'Voiture' && dayPrice === 0 && halfDayPrice === 0) {
                        dayPrice = assetPrice.DayPrice;
                        halfDayPrice = assetPrice.SemiDayPrice;

                        $dayCarReplacement.attr('data-price', dayPrice);
                        $dayCarReplacement.find('span').remove();
                        $dayCarReplacement.append(`<span> (${currency} ${dayPrice})</span>`);

                        $halfDayCarReplacement.attr('data-price', halfDayPrice);
                        $halfDayCarReplacement.find('span').remove();
                        $halfDayCarReplacement.append(`<span> (${currency} ${halfDayPrice})</span>`);
                        isHaveReplacement = true;
                    }
                });

                if (isHaveReplacement) {
                    replacements(true);
                } else {
                    replacements(false);
                }
            } else {
                replacements(false);
            }
        },
        error: function (error) {
            replacements(false);
            console.log(error);
        },
    });
}
